<div
    class="cm-user-thumbnail"
    [class.cm-user-thumbnail--medium]="$size() === 'medium'"
    [class.cm-user-thumbnail--full]="$size() === '100%'"
    [class.cm-user-thumbnail--rounded]="$rounded()"
>
    @if ($user()?.galleryImage?.id; as dataObjectId) {
        <cm-data-object-thumbnail
            class="cm-user-thumbnail-picture"
            [dataObjectId]="dataObjectId"
            [resolution]="DownloadResolution.Tiny"
            [layout]="ThumbnailLayout.Cover"
            [fallbackToOriginal]="true"
        ></cm-data-object-thumbnail>
    } @else {
        <i class="fa-solid fa-circle-user"></i>
    }
</div>
